// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";

function toString(shifting_type) {
  switch (shifting_type.TAG | 0) {
    case /* Inter */0 :
        return "inter_city";
    case /* Intra */1 :
        return "intra_city";
    case /* Labour */2 :
        return "labour";
    
  }
}

function fromString(shifting_type, geo_region_id, pickup_geo_region_id, drop_geo_region_id) {
  switch (shifting_type) {
    case "inter_city" :
        if (pickup_geo_region_id !== undefined && drop_geo_region_id !== undefined) {
          return {
                  TAG: /* Inter */0,
                  _0: {
                    pickup_geo_region_id: pickup_geo_region_id,
                    drop_geo_region_id: drop_geo_region_id
                  }
                };
        } else {
          return ErrorUtils$Catalyst.raiseError("PnMShiftingType.res", "Invalid Shifting Type", "");
        }
    case "intra_city" :
        if (geo_region_id !== undefined) {
          return {
                  TAG: /* Intra */1,
                  _0: geo_region_id
                };
        } else {
          return ErrorUtils$Catalyst.raiseError("PnMShiftingType.res", "Invalid Shifting Type", "");
        }
    case "labour" :
        if (geo_region_id !== undefined) {
          return {
                  TAG: /* Labour */2,
                  _0: geo_region_id
                };
        } else {
          return ErrorUtils$Catalyst.raiseError("PnMShiftingType.res", "Invalid Shifting Type", "");
        }
    default:
      return ErrorUtils$Catalyst.raiseError("PnMShiftingType.res", "Invalid Shifting Type", "");
  }
}

export {
  toString ,
  fromString ,
}
/* No side effect */
